import { useContext } from 'react';
import { i18n } from '@lingui/core';
import { Stack } from '@mantine/core';
import { ContactContext } from '../Service/Context/ContactContext';
import BookitupTextInput from '../Atoms/inputs/BookitupTextInput';
import PanePaper from './PanePaper';

const ContactForm = () => {
  const { contact, saveContactChange } = useContext<any>(ContactContext);
  const { addressStreetAndNo, zipCode, city, phoneNumber } = contact;

  return (
    <PanePaper title="common.settings.address">
      <Stack spacing="xs">
        <BookitupTextInput
          label={i18n._('contact.streetAndNo')}
          defaultValue={addressStreetAndNo}
          onBlurSave={(val) => saveContactChange({ addressStreetAndNo: val })}
        />
        <BookitupTextInput
          label={i18n._('contact.zipCode')}
          defaultValue={zipCode}
          onBlurSave={(val) => saveContactChange({ zipCode: val })}
        />
        <BookitupTextInput
          label={i18n._('contact.city')}
          defaultValue={city}
          onBlurSave={(val) => saveContactChange({ city: val })}
        />
        <BookitupTextInput
          label={i18n._('contact.phoneNumber')}
          defaultValue={phoneNumber}
          onBlurSave={(val) => saveContactChange({ phoneNumber: val })}
        />
      </Stack>
    </PanePaper>
  );
};

export default ContactForm;
